import { render, staticRenderFns } from "./VDialog.vue?vue&type=template&id=4eedb5b9&scoped=true"
import script from "./VDialog.vue?vue&type=script&lang=js"
export * from "./VDialog.vue?vue&type=script&lang=js"
import style0 from "./VDialog.vue?vue&type=style&index=0&id=4eedb5b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eedb5b9",
  null
  
)

export default component.exports